<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title" *ngIf ="option === 'N'">Create New Template</h3>
    <h3 class="modal-title" *ngIf ="option === 'C'">Copy New Template</h3>
</div>
<div class="modal-body">
    <div *ngIf ="option === 'C'">
        <label><strong>Copy From:</strong></label>
        <ng-select [(ngModel)]="formData.oldTemplate"
                   [clearable]=false
                   [searchable]="false">
            <ng-option *ngFor="let template of templateList" [value]="template.ChecklistTemplateID">{{template.ChecklistTemplateName}}</ng-option>
        </ng-select>
    </div>
    <label><strong>Template Name:</strong></label>
    <input type="text" class="form-control"
           [(ngModel)]="formData.newTemplate" />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" *ngIf="option === 'N'" (click)="createClicked()" [disabled]="formData.newTemplate == null || formData.newTemplate.trim() === ''">Create</button>
    <button type="button" class="btn btn-primary" *ngIf="option === 'C'" (click)="copyClicked()" [disabled]="formData.oldTemplate == null || (formData.newTemplate == null || formData.newTemplate.trim() === '')">Copy</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>